import React from 'react';

const Zoology = () => {
  return (
    <div>
      Zoology
      Zoology
    </div>
  );
}

export default Zoology;
